import React, { useState, useEffect } from 'react';
import { getDocList } from '../services';
import Loading from './DocList/Loading';

const PodcastList = ({ profile }) => {
  const sortSettings = {
    title: {
      label: 'Title',
      direction: 'DESC',
    },
    author: { label: 'Author', direction: 'DESC', active: false },
    site: { label: 'Site', direction: 'DESC', active: false },
    publishDate: { label: 'Publish Date', direction: 'DESC', active: true },
  };
  const [sortBy, setSortBy] = useState(sortSettings);
  const [sortValue, setSortValue] = useState(['publishDate-']);
  const [isFetching, setIsFetching] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [nextToken, setNextToken] = useState(0);
  const [tags, setTags] = useState([]);
  const [docs, setDocs] = useState({
    items: [],
    nextToken: 0,
  });
  useEffect(() => {
    setIsFetching(true);
    if (profile) {
      getDocList(
        profile.profileId,
        'watchlist',
        sortValue,
        nextToken + 1,
        10,
        tags
      ).then((res) => {
        setIsFetching(false);
        if (res.status === 200) {
          setDocs(res.documents);
        }
      });
    }
  }, [profile]);

  return (
    <div>
      <h5>Podcasts</h5>
      {isFetching ? <Loading text='loading Podcasts' /> : null}
      {docs.length ? (
        <div id='podcast-list' className='podcast-list'>
          {Object.entries(docs.items).map(([key, value]) => (
            <div className='cve-meta' key={value.id}>
              <span className='cve-id'>{value.id}</span>
              <h4>{value.title}</h4>
              <span className='cve-field-group cve-publish-date'>
                <span className='cve-label'>Published on:</span>
                <span className='cve-value'>{value.publishDate}</span>
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
export default PodcastList;
